<template>
<div class="chapter">
<div class="inner_page">
<div style="font-size: 210%; margin-top:10%"><span>Contents</span></div>
<div class="top-margin"></div>
<div class="toc1" style="margin-top:0em"><span><a href="#/ack#toc1a" id="toc1">     Acknowledgments</a></span></div>
<div class="toc1"><span><a href="#/introduction#toc2a" id="toc2">     Introduction</a></span></div>
<div class="toc1"><span><a href="#/ch01#toc3a" id="toc3"><b>1</b>   How Real Are the Elementary Particles?</a></span></div>
<div class="toc1"><span><span href="#/ch02#toc4a" id="toc4" title="Link target outside of Sample"><b>2</b>   The Emergence of Complexity; and an Interview with Matthieu Ricard</span></span></div>
<div class="toc1"><span><span href="#/ch03#toc5a" id="toc5" title="Link target outside of Sample"><b>3</b>   Toward the Complexity of Life</span></span></div>
<div class="toc1"><span><span href="#/ch04#toc6a" id="toc6" title="Link target outside of Sample"><b>4</b>   How Life Unfolds; and an Interview with Richard Gere</span></span></div>
<div class="toc1"><span><span href="#/ch05#toc7a" id="toc7" title="Link target outside of Sample"><b>5</b>   The Magic of the Human Genome and Its Ethical Problems; and an Interview with His Holiness the Karmapa</span></span></div>
<div class="toc1"><span><span href="#/ch06#toc8a" id="toc8" title="Link target outside of Sample"><b>6</b>   From Consciousness to Ethics</span></span></div>
<div class="toc1"><span><span href="#/ch07#toc9a" id="toc9" title="Link target outside of Sample"><b>7</b>   Last Words</span></span></div>
<div class="toc2"><span><span href="#/about#toc10a" id="toc10" title="Link target outside of Sample">About the Mind and Life Institute</span></span></div>
<div> </div>
<div class="toc2"><span><span href="#/notes#toc11a" id="toc11" title="Link target outside of Sample">Notes</span></span></div>
<div class="toc2"><span><span href="#/index#toc12a" id="toc12" title="Link target outside of Sample">Index</span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?759eb554